import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SearchProvider } from "@/context/SearchContext";
import { CrawlProvider } from "@/context/CrawlContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { InstallPrompt } from "@/components/InstallPrompt";
import Home from "@/pages/Home";
import MapPage from "@/pages/MapPage";
import VenueDetail from "@/pages/VenueDetail";
import Saved from "@/pages/Saved";
import Crawl from "@/pages/Crawl";
import SharedCrawl from "@/pages/SharedCrawl";
import SubmitSpecials from "@/pages/SubmitSpecials";
import Featured from "@/pages/Featured";
import Advertise from "@/pages/Advertise";
import AdvertiseConfirm from "@/pages/AdvertiseConfirm";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <SearchProvider>
            <CrawlProvider>
              <ScrollTop />
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/map" element={<MapPage />} />
                  <Route path="/venue/:id" element={<VenueDetail />} />
                  <Route path="/saved" element={<Saved />} />
                  <Route path="/crawl" element={<Crawl />} />
                  <Route path="/crawl/:id" element={<SharedCrawl />} />
                  <Route path="/submit" element={<SubmitSpecials />} />
                  <Route path="/featured" element={<Featured />} />
                  <Route path="/advertise" element={<Advertise />} />
                  <Route path="/advertise/confirmation/:id" element={<AdvertiseConfirm />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </main>
              <Footer />
              <InstallPrompt />
              <Toaster theme="dark" position="top-center" />
            </CrawlProvider>
          </SearchProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
